// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../../common/types/App_Types_Date.bs.js";
import * as App_Types_Json$DvmAdminFrontendFr from "../../../common/types/App_Types_Json.bs.js";
import * as App_Types_Status$DvmAdminFrontendFr from "../../../common/types/App_Types_Status.bs.js";
import * as App_Types_VN_VO_Status$DvmAdminFrontendFr from "../../../common/types/App_Types_VN_VO_Status.bs.js";
import * as Order_Detail_Types_Comment$DvmAdminFrontendFr from "./Order_Detail_Types_Comment.bs.js";
import * as Order_Detail_Types_Order_Type$DvmAdminFrontendFr from "./Order_Detail_Types_Order_Type.bs.js";

function bonusChangeInfo_encode(v) {
  return Js_dict.fromArray([
              [
                "date",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.date)
              ],
              [
                "approver",
                Decco.optionToJson(Decco.stringToJson, v.approver)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ],
              [
                "approved",
                Decco.optionToJson(Decco.boolToJson, v.approved)
              ]
            ]);
}

function bonusChangeInfo_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var date = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "date"), null));
  if (date.TAG === /* Ok */0) {
    var approver = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approver"), null));
    if (approver.TAG === /* Ok */0) {
      var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
      if (comment.TAG === /* Ok */0) {
        var approved = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approved"), null));
        if (approved.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    date: date._0,
                    approver: approver._0,
                    comment: comment._0,
                    approved: approved._0
                  }
                };
        }
        var e = approved._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".approved" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = comment._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".comment" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = approver._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".approver" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = date._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".date" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function toString(status) {
  switch (status) {
    case /* INFO */0 :
        return "INFO";
    case /* ERROR */1 :
        return "ERROR";
    case /* ERROR_ARCHIVED */2 :
        return "ERROR_ARCHIVED";
    
  }
}

function fromString(status) {
  switch (status) {
    case "ERROR" :
        return /* ERROR */1;
    case "ERROR_ARCHIVED" :
        return /* ERROR_ARCHIVED */2;
    case "INFO" :
        return /* INFO */0;
    default:
      return ;
  }
}

var Decco$1 = App_Types_Json$DvmAdminFrontendFr.MakeStringableJsonType({
      toString: toString,
      fromString: fromString
    });

var MessageType = {
  toString: toString,
  fromString: fromString,
  Decco: Decco$1
};

function messagesItem_encode(v) {
  return Js_dict.fromArray([
              [
                "messageId",
                Curry._1(Order_Detail_Types_Comment$DvmAdminFrontendFr.Decco.t_encode, v.messageId)
              ],
              [
                "messageLabel",
                Decco.optionToJson(Decco.stringToJson, v.messageLabel)
              ],
              [
                "messageType",
                Curry._1(Decco$1.t_encode, v.messageType)
              ]
            ]);
}

function messagesItem_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var messageId = Curry._1(Order_Detail_Types_Comment$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageId"), null));
  if (messageId.TAG === /* Ok */0) {
    var messageLabel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageLabel"), null));
    if (messageLabel.TAG === /* Ok */0) {
      var messageType = Curry._1(Decco$1.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageType"), null));
      if (messageType.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  messageId: messageId._0,
                  messageLabel: messageLabel._0,
                  messageType: messageType._0
                }
              };
      }
      var e = messageType._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".messageType" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = messageLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".messageLabel" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = messageId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".messageId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "derogationId",
                Decco.stringToJson(v.derogationId)
              ],
              [
                "derogationStatus",
                Decco.optionToJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_encode, v.derogationStatus)
              ],
              [
                "derogationLabel",
                Decco.optionToJson(Decco.stringToJson, v.derogationLabel)
              ],
              [
                "derogationAmount",
                Decco.optionToJson(Decco.floatToJson, v.derogationAmount)
              ],
              [
                "derogationAmountTtc",
                Decco.optionToJson(Decco.floatToJson, v.derogationAmountTtc)
              ],
              [
                "derogationAmountPaid",
                Decco.optionToJson(Decco.floatToJson, v.derogationAmountPaid)
              ],
              [
                "derogationAmountOriginal",
                Decco.optionToJson(Decco.floatToJson, v.derogationAmountOriginal)
              ],
              [
                "derogationComment",
                Decco.optionToJson(Decco.stringToJson, v.derogationComment)
              ],
              [
                "derogationValidation",
                Decco.optionToJson(Decco.stringToJson, v.derogationValidation)
              ],
              [
                "dateOfDerogation",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.dateOfDerogation)
              ],
              [
                "derogationEditor",
                Decco.optionToJson(Decco.stringToJson, v.derogationEditor)
              ],
              [
                "derogatedActionId",
                Decco.optionToJson(Decco.stringToJson, v.derogatedActionId)
              ],
              [
                "derogatedActionType",
                Decco.optionToJson(Decco.stringToJson, v.derogatedActionType)
              ],
              [
                "derogatedOrderType",
                Decco.optionToJson(Decco.stringToJson, v.derogatedOrderType)
              ],
              [
                "derogatedActionPreinvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.derogatedActionPreinvoiceDate)
              ],
              [
                "derogatedActionPreinvoiceNumber",
                Decco.optionToJson(Decco.stringToJson, v.derogatedActionPreinvoiceNumber)
              ],
              [
                "messages",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(messagesItem_encode, param);
                      }), v.messages)
              ],
              [
                "resultActionStatus",
                Decco.optionToJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_encode, v.resultActionStatus)
              ],
              [
                "derogationNegative",
                Decco.boolToJson(v.derogationNegative)
              ],
              [
                "derogatedActionWithUsedCar",
                Decco.optionToJson(Decco.boolToJson, v.derogatedActionWithUsedCar)
              ],
              [
                "invoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.invoiceDate)
              ],
              [
                "requestType",
                Decco.optionToJson(Decco.stringToJson, v.requestType)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var derogationId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationId"), null));
  if (derogationId.TAG === /* Ok */0) {
    var derogationStatus = Decco.optionFromJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationStatus"), null));
    if (derogationStatus.TAG === /* Ok */0) {
      var derogationLabel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationLabel"), null));
      if (derogationLabel.TAG === /* Ok */0) {
        var derogationAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationAmount"), null));
        if (derogationAmount.TAG === /* Ok */0) {
          var derogationAmountTtc = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationAmountTtc"), null));
          if (derogationAmountTtc.TAG === /* Ok */0) {
            var derogationAmountPaid = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationAmountPaid"), null));
            if (derogationAmountPaid.TAG === /* Ok */0) {
              var derogationAmountOriginal = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationAmountOriginal"), null));
              if (derogationAmountOriginal.TAG === /* Ok */0) {
                var derogationComment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationComment"), null));
                if (derogationComment.TAG === /* Ok */0) {
                  var derogationValidation = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationValidation"), null));
                  if (derogationValidation.TAG === /* Ok */0) {
                    var dateOfDerogation = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dateOfDerogation"), null));
                    if (dateOfDerogation.TAG === /* Ok */0) {
                      var derogationEditor = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationEditor"), null));
                      if (derogationEditor.TAG === /* Ok */0) {
                        var derogatedActionId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedActionId"), null));
                        if (derogatedActionId.TAG === /* Ok */0) {
                          var derogatedActionType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedActionType"), null));
                          if (derogatedActionType.TAG === /* Ok */0) {
                            var derogatedOrderType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedOrderType"), null));
                            if (derogatedOrderType.TAG === /* Ok */0) {
                              var derogatedActionPreinvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedActionPreinvoiceDate"), null));
                              if (derogatedActionPreinvoiceDate.TAG === /* Ok */0) {
                                var derogatedActionPreinvoiceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedActionPreinvoiceNumber"), null));
                                if (derogatedActionPreinvoiceNumber.TAG === /* Ok */0) {
                                  var messages = Decco.optionFromJson((function (param) {
                                          return Decco.listFromJson(messagesItem_decode, param);
                                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "messages"), null));
                                  if (messages.TAG === /* Ok */0) {
                                    var resultActionStatus = Decco.optionFromJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultActionStatus"), null));
                                    if (resultActionStatus.TAG === /* Ok */0) {
                                      var derogationNegative = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogationNegative"), null));
                                      if (derogationNegative.TAG === /* Ok */0) {
                                        var derogatedActionWithUsedCar = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogatedActionWithUsedCar"), null));
                                        if (derogatedActionWithUsedCar.TAG === /* Ok */0) {
                                          var invoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "invoiceDate"), null));
                                          if (invoiceDate.TAG === /* Ok */0) {
                                            var requestType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "requestType"), null));
                                            if (requestType.TAG === /* Ok */0) {
                                              return {
                                                      TAG: /* Ok */0,
                                                      _0: {
                                                        derogationId: derogationId._0,
                                                        derogationStatus: derogationStatus._0,
                                                        derogationLabel: derogationLabel._0,
                                                        derogationAmount: derogationAmount._0,
                                                        derogationAmountTtc: derogationAmountTtc._0,
                                                        derogationAmountPaid: derogationAmountPaid._0,
                                                        derogationAmountOriginal: derogationAmountOriginal._0,
                                                        derogationComment: derogationComment._0,
                                                        derogationValidation: derogationValidation._0,
                                                        dateOfDerogation: dateOfDerogation._0,
                                                        derogationEditor: derogationEditor._0,
                                                        derogatedActionId: derogatedActionId._0,
                                                        derogatedActionType: derogatedActionType._0,
                                                        derogatedOrderType: derogatedOrderType._0,
                                                        derogatedActionPreinvoiceDate: derogatedActionPreinvoiceDate._0,
                                                        derogatedActionPreinvoiceNumber: derogatedActionPreinvoiceNumber._0,
                                                        messages: messages._0,
                                                        resultActionStatus: resultActionStatus._0,
                                                        derogationNegative: derogationNegative._0,
                                                        derogatedActionWithUsedCar: derogatedActionWithUsedCar._0,
                                                        invoiceDate: invoiceDate._0,
                                                        requestType: requestType._0
                                                      }
                                                    };
                                            }
                                            var e = requestType._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".requestType" + e.path,
                                                      message: e.message,
                                                      value: e.value
                                                    }
                                                  };
                                          }
                                          var e$1 = invoiceDate._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".invoiceDate" + e$1.path,
                                                    message: e$1.message,
                                                    value: e$1.value
                                                  }
                                                };
                                        }
                                        var e$2 = derogatedActionWithUsedCar._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".derogatedActionWithUsedCar" + e$2.path,
                                                  message: e$2.message,
                                                  value: e$2.value
                                                }
                                              };
                                      }
                                      var e$3 = derogationNegative._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".derogationNegative" + e$3.path,
                                                message: e$3.message,
                                                value: e$3.value
                                              }
                                            };
                                    }
                                    var e$4 = resultActionStatus._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".resultActionStatus" + e$4.path,
                                              message: e$4.message,
                                              value: e$4.value
                                            }
                                          };
                                  }
                                  var e$5 = messages._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".messages" + e$5.path,
                                            message: e$5.message,
                                            value: e$5.value
                                          }
                                        };
                                }
                                var e$6 = derogatedActionPreinvoiceNumber._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".derogatedActionPreinvoiceNumber" + e$6.path,
                                          message: e$6.message,
                                          value: e$6.value
                                        }
                                      };
                              }
                              var e$7 = derogatedActionPreinvoiceDate._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".derogatedActionPreinvoiceDate" + e$7.path,
                                        message: e$7.message,
                                        value: e$7.value
                                      }
                                    };
                            }
                            var e$8 = derogatedOrderType._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".derogatedOrderType" + e$8.path,
                                      message: e$8.message,
                                      value: e$8.value
                                    }
                                  };
                          }
                          var e$9 = derogatedActionType._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".derogatedActionType" + e$9.path,
                                    message: e$9.message,
                                    value: e$9.value
                                  }
                                };
                        }
                        var e$10 = derogatedActionId._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".derogatedActionId" + e$10.path,
                                  message: e$10.message,
                                  value: e$10.value
                                }
                              };
                      }
                      var e$11 = derogationEditor._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".derogationEditor" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                              }
                            };
                    }
                    var e$12 = dateOfDerogation._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".dateOfDerogation" + e$12.path,
                              message: e$12.message,
                              value: e$12.value
                            }
                          };
                  }
                  var e$13 = derogationValidation._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".derogationValidation" + e$13.path,
                            message: e$13.message,
                            value: e$13.value
                          }
                        };
                }
                var e$14 = derogationComment._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".derogationComment" + e$14.path,
                          message: e$14.message,
                          value: e$14.value
                        }
                      };
              }
              var e$15 = derogationAmountOriginal._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".derogationAmountOriginal" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                      }
                    };
            }
            var e$16 = derogationAmountPaid._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".derogationAmountPaid" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = derogationAmountTtc._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".derogationAmountTtc" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
        }
        var e$18 = derogationAmount._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".derogationAmount" + e$18.path,
                  message: e$18.message,
                  value: e$18.value
                }
              };
      }
      var e$19 = derogationLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".derogationLabel" + e$19.path,
                message: e$19.message,
                value: e$19.value
              }
            };
    }
    var e$20 = derogationStatus._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".derogationStatus" + e$20.path,
              message: e$20.message,
              value: e$20.value
            }
          };
  }
  var e$21 = derogationId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".derogationId" + e$21.path,
            message: e$21.message,
            value: e$21.value
          }
        };
}

var OrderDero = {
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "resultActionStatus",
                Decco.optionToJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_encode, v.resultActionStatus)
              ],
              [
                "actionType",
                Decco.optionToJson(Decco.stringToJson, v.actionType)
              ],
              [
                "actionId",
                Decco.optionToJson(Decco.stringToJson, v.actionId)
              ],
              [
                "actionLabel",
                Decco.optionToJson(Decco.stringToJson, v.actionLabel)
              ],
              [
                "resultPreinvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultPreinvoiceDate)
              ],
              [
                "resultPreinvoiceNumber",
                Decco.optionToJson(Decco.stringToJson, v.resultPreinvoiceNumber)
              ],
              [
                "resultInvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultInvoiceDate)
              ],
              [
                "messages",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(messagesItem_encode, param);
                      }), v.messages)
              ],
              [
                "deros",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(t_encode, param);
                      }), v.deros)
              ],
              [
                "actionIsPARCExit",
                Decco.optionToJson(Decco.boolToJson, v.actionIsPARCExit)
              ],
              [
                "actionWithUsedCar",
                Decco.optionToJson(Decco.boolToJson, v.actionWithUsedCar)
              ],
              [
                "resultBudgetYear",
                Decco.optionToJson(Decco.stringToJson, v.resultBudgetYear)
              ],
              [
                "resultBonus",
                Decco.optionToJson(Decco.floatToJson, v.resultBonus)
              ],
              [
                "resultBonusVat",
                Decco.optionToJson(Decco.floatToJson, v.resultBonusVat)
              ],
              [
                "resultBonusPaid",
                Decco.optionToJson(Decco.floatToJson, v.resultBonusPaid)
              ],
              [
                "perfApproval",
                Decco.optionToJson(bonusChangeInfo_encode, v.perfApproval)
              ],
              [
                "actionBonusValue",
                Decco.optionToJson(Decco.floatToJson, v.actionBonusValue)
              ],
              [
                "actionBonusPercentage",
                Decco.optionToJson(Decco.floatToJson, v.actionBonusPercentage)
              ],
              [
                "actionCalcMethod",
                Decco.optionToJson(Decco.stringToJson, v.actionCalcMethod)
              ],
              [
                "requestType",
                Decco.optionToJson(Decco.stringToJson, v.requestType)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var resultActionStatus = Decco.optionFromJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultActionStatus"), null));
  if (resultActionStatus.TAG === /* Ok */0) {
    var actionType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionType"), null));
    if (actionType.TAG === /* Ok */0) {
      var actionId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionId"), null));
      if (actionId.TAG === /* Ok */0) {
        var actionLabel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionLabel"), null));
        if (actionLabel.TAG === /* Ok */0) {
          var resultPreinvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPreinvoiceDate"), null));
          if (resultPreinvoiceDate.TAG === /* Ok */0) {
            var resultPreinvoiceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPreinvoiceNumber"), null));
            if (resultPreinvoiceNumber.TAG === /* Ok */0) {
              var resultInvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultInvoiceDate"), null));
              if (resultInvoiceDate.TAG === /* Ok */0) {
                var messages = Decco.optionFromJson((function (param) {
                        return Decco.listFromJson(messagesItem_decode, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "messages"), null));
                if (messages.TAG === /* Ok */0) {
                  var deros = Decco.optionFromJson((function (param) {
                          return Decco.listFromJson(t_decode, param);
                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "deros"), null));
                  if (deros.TAG === /* Ok */0) {
                    var actionIsPARCExit = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionIsPARCExit"), null));
                    if (actionIsPARCExit.TAG === /* Ok */0) {
                      var actionWithUsedCar = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionWithUsedCar"), null));
                      if (actionWithUsedCar.TAG === /* Ok */0) {
                        var resultBudgetYear = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBudgetYear"), null));
                        if (resultBudgetYear.TAG === /* Ok */0) {
                          var resultBonus = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBonus"), null));
                          if (resultBonus.TAG === /* Ok */0) {
                            var resultBonusVat = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBonusVat"), null));
                            if (resultBonusVat.TAG === /* Ok */0) {
                              var resultBonusPaid = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBonusPaid"), null));
                              if (resultBonusPaid.TAG === /* Ok */0) {
                                var perfApproval = Decco.optionFromJson(bonusChangeInfo_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "perfApproval"), null));
                                if (perfApproval.TAG === /* Ok */0) {
                                  var actionBonusValue = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionBonusValue"), null));
                                  if (actionBonusValue.TAG === /* Ok */0) {
                                    var actionBonusPercentage = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionBonusPercentage"), null));
                                    if (actionBonusPercentage.TAG === /* Ok */0) {
                                      var actionCalcMethod = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionCalcMethod"), null));
                                      if (actionCalcMethod.TAG === /* Ok */0) {
                                        var requestType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "requestType"), null));
                                        if (requestType.TAG === /* Ok */0) {
                                          return {
                                                  TAG: /* Ok */0,
                                                  _0: {
                                                    resultActionStatus: resultActionStatus._0,
                                                    actionType: actionType._0,
                                                    actionId: actionId._0,
                                                    actionLabel: actionLabel._0,
                                                    resultPreinvoiceDate: resultPreinvoiceDate._0,
                                                    resultPreinvoiceNumber: resultPreinvoiceNumber._0,
                                                    resultInvoiceDate: resultInvoiceDate._0,
                                                    messages: messages._0,
                                                    deros: deros._0,
                                                    actionIsPARCExit: actionIsPARCExit._0,
                                                    actionWithUsedCar: actionWithUsedCar._0,
                                                    resultBudgetYear: resultBudgetYear._0,
                                                    resultBonus: resultBonus._0,
                                                    resultBonusVat: resultBonusVat._0,
                                                    resultBonusPaid: resultBonusPaid._0,
                                                    perfApproval: perfApproval._0,
                                                    actionBonusValue: actionBonusValue._0,
                                                    actionBonusPercentage: actionBonusPercentage._0,
                                                    actionCalcMethod: actionCalcMethod._0,
                                                    requestType: requestType._0
                                                  }
                                                };
                                        }
                                        var e = requestType._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".requestType" + e.path,
                                                  message: e.message,
                                                  value: e.value
                                                }
                                              };
                                      }
                                      var e$1 = actionCalcMethod._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".actionCalcMethod" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                              }
                                            };
                                    }
                                    var e$2 = actionBonusPercentage._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".actionBonusPercentage" + e$2.path,
                                              message: e$2.message,
                                              value: e$2.value
                                            }
                                          };
                                  }
                                  var e$3 = actionBonusValue._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".actionBonusValue" + e$3.path,
                                            message: e$3.message,
                                            value: e$3.value
                                          }
                                        };
                                }
                                var e$4 = perfApproval._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".perfApproval" + e$4.path,
                                          message: e$4.message,
                                          value: e$4.value
                                        }
                                      };
                              }
                              var e$5 = resultBonusPaid._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".resultBonusPaid" + e$5.path,
                                        message: e$5.message,
                                        value: e$5.value
                                      }
                                    };
                            }
                            var e$6 = resultBonusVat._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".resultBonusVat" + e$6.path,
                                      message: e$6.message,
                                      value: e$6.value
                                    }
                                  };
                          }
                          var e$7 = resultBonus._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".resultBonus" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                  }
                                };
                        }
                        var e$8 = resultBudgetYear._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".resultBudgetYear" + e$8.path,
                                  message: e$8.message,
                                  value: e$8.value
                                }
                              };
                      }
                      var e$9 = actionWithUsedCar._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".actionWithUsedCar" + e$9.path,
                                message: e$9.message,
                                value: e$9.value
                              }
                            };
                    }
                    var e$10 = actionIsPARCExit._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".actionIsPARCExit" + e$10.path,
                              message: e$10.message,
                              value: e$10.value
                            }
                          };
                  }
                  var e$11 = deros._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".deros" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                          }
                        };
                }
                var e$12 = messages._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".messages" + e$12.path,
                          message: e$12.message,
                          value: e$12.value
                        }
                      };
              }
              var e$13 = resultInvoiceDate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".resultInvoiceDate" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                      }
                    };
            }
            var e$14 = resultPreinvoiceNumber._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".resultPreinvoiceNumber" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = resultPreinvoiceDate._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".resultPreinvoiceDate" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
        }
        var e$16 = actionLabel._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".actionLabel" + e$16.path,
                  message: e$16.message,
                  value: e$16.value
                }
              };
      }
      var e$17 = actionId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".actionId" + e$17.path,
                message: e$17.message,
                value: e$17.value
              }
            };
    }
    var e$18 = actionType._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actionType" + e$18.path,
              message: e$18.message,
              value: e$18.value
            }
          };
  }
  var e$19 = resultActionStatus._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".resultActionStatus" + e$19.path,
            message: e$19.message,
            value: e$19.value
          }
        };
}

var OrderBonus = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "resultActionStatus",
                Decco.optionToJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_encode, v.resultActionStatus)
              ],
              [
                "orderBudgetType",
                Decco.optionToJson(Decco.stringToJson, v.orderBudgetType)
              ],
              [
                "resultBudgetYear",
                Decco.optionToJson(Decco.stringToJson, v.resultBudgetYear)
              ],
              [
                "orderAcquisitionType",
                Decco.optionToJson(Decco.stringToJson, v.orderAcquisitionType)
              ],
              [
                "resultPreinvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultPreinvoiceDate)
              ],
              [
                "resultPreinvoiceNumber",
                Decco.optionToJson(Decco.stringToJson, v.resultPreinvoiceNumber)
              ],
              [
                "resultInvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultInvoiceDate)
              ],
              [
                "orderCompanyDiscount",
                Decco.optionToJson(Decco.floatToJson, v.orderCompanyDiscount)
              ],
              [
                "messages",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(messagesItem_encode, param);
                      }), v.messages)
              ],
              [
                "deros",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(t_encode, param);
                      }), v.deros)
              ],
              [
                "bypassDetail",
                Decco.optionToJson(bonusChangeInfo_encode, v.bypassDetail)
              ],
              [
                "resultDiscountGrid",
                Decco.optionToJson(Decco.floatToJson, v.resultDiscountGrid)
              ],
              [
                "actionBonusValue",
                Decco.optionToJson(Decco.floatToJson, v.actionBonusValue)
              ],
              [
                "resultBonus",
                Decco.optionToJson(Decco.floatToJson, v.resultBonus)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var resultActionStatus = Decco.optionFromJson(App_Types_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultActionStatus"), null));
  if (resultActionStatus.TAG === /* Ok */0) {
    var orderBudgetType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderBudgetType"), null));
    if (orderBudgetType.TAG === /* Ok */0) {
      var resultBudgetYear = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBudgetYear"), null));
      if (resultBudgetYear.TAG === /* Ok */0) {
        var orderAcquisitionType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderAcquisitionType"), null));
        if (orderAcquisitionType.TAG === /* Ok */0) {
          var resultPreinvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPreinvoiceDate"), null));
          if (resultPreinvoiceDate.TAG === /* Ok */0) {
            var resultPreinvoiceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPreinvoiceNumber"), null));
            if (resultPreinvoiceNumber.TAG === /* Ok */0) {
              var resultInvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultInvoiceDate"), null));
              if (resultInvoiceDate.TAG === /* Ok */0) {
                var orderCompanyDiscount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCompanyDiscount"), null));
                if (orderCompanyDiscount.TAG === /* Ok */0) {
                  var messages = Decco.optionFromJson((function (param) {
                          return Decco.listFromJson(messagesItem_decode, param);
                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "messages"), null));
                  if (messages.TAG === /* Ok */0) {
                    var deros = Decco.optionFromJson((function (param) {
                            return Decco.listFromJson(t_decode, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "deros"), null));
                    if (deros.TAG === /* Ok */0) {
                      var bypassDetail = Decco.optionFromJson(bonusChangeInfo_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "bypassDetail"), null));
                      if (bypassDetail.TAG === /* Ok */0) {
                        var resultDiscountGrid = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultDiscountGrid"), null));
                        if (resultDiscountGrid.TAG === /* Ok */0) {
                          var actionBonusValue = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionBonusValue"), null));
                          if (actionBonusValue.TAG === /* Ok */0) {
                            var resultBonus = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultBonus"), null));
                            if (resultBonus.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        resultActionStatus: resultActionStatus._0,
                                        orderBudgetType: orderBudgetType._0,
                                        resultBudgetYear: resultBudgetYear._0,
                                        orderAcquisitionType: orderAcquisitionType._0,
                                        resultPreinvoiceDate: resultPreinvoiceDate._0,
                                        resultPreinvoiceNumber: resultPreinvoiceNumber._0,
                                        resultInvoiceDate: resultInvoiceDate._0,
                                        orderCompanyDiscount: orderCompanyDiscount._0,
                                        messages: messages._0,
                                        deros: deros._0,
                                        bypassDetail: bypassDetail._0,
                                        resultDiscountGrid: resultDiscountGrid._0,
                                        actionBonusValue: actionBonusValue._0,
                                        resultBonus: resultBonus._0
                                      }
                                    };
                            }
                            var e = resultBonus._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".resultBonus" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = actionBonusValue._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".actionBonusValue" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = resultDiscountGrid._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".resultDiscountGrid" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = bypassDetail._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".bypassDetail" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = deros._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".deros" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = messages._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".messages" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = orderCompanyDiscount._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".orderCompanyDiscount" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = resultInvoiceDate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".resultInvoiceDate" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = resultPreinvoiceNumber._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".resultPreinvoiceNumber" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = resultPreinvoiceDate._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".resultPreinvoiceDate" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = orderAcquisitionType._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".orderAcquisitionType" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = resultBudgetYear._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".resultBudgetYear" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = orderBudgetType._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".orderBudgetType" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = resultActionStatus._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".resultActionStatus" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

var OrderBudget = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function orderUsedCar_encode(v) {
  return Js_dict.fromArray([
              [
                "orderUcBrand",
                Decco.optionToJson(Decco.stringToJson, v.orderUcBrand)
              ],
              [
                "orderUcModel",
                Decco.optionToJson(Decco.stringToJson, v.orderUcModel)
              ],
              [
                "orderUcVersion",
                Decco.optionToJson(Decco.stringToJson, v.orderUcVersion)
              ],
              [
                "orderUcRegistrationId",
                Decco.optionToJson(Decco.stringToJson, v.orderUcRegistrationId)
              ],
              [
                "orderUcVin",
                Decco.optionToJson(Decco.stringToJson, v.orderUcVin)
              ],
              [
                "ucPoliceNumber",
                Decco.optionToJson(Decco.stringToJson, v.ucPoliceNumber)
              ],
              [
                "orderUCFirstReleaseDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderUCFirstReleaseDate)
              ],
              [
                "orderUCLastRegistrationDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderUCLastRegistrationDate)
              ],
              [
                "orderRealTradeAmount",
                Decco.optionToJson(Decco.floatToJson, v.orderRealTradeAmount)
              ],
              [
                "orderEstimatedTradeAmount",
                Decco.optionToJson(Decco.floatToJson, v.orderEstimatedTradeAmount)
              ],
              [
                "orderScrapyardIndicator",
                Decco.optionToJson(Decco.boolToJson, v.orderScrapyardIndicator)
              ]
            ]);
}

function orderUsedCar_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var orderUcBrand = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUcBrand"), null));
  if (orderUcBrand.TAG === /* Ok */0) {
    var orderUcModel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUcModel"), null));
    if (orderUcModel.TAG === /* Ok */0) {
      var orderUcVersion = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUcVersion"), null));
      if (orderUcVersion.TAG === /* Ok */0) {
        var orderUcRegistrationId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUcRegistrationId"), null));
        if (orderUcRegistrationId.TAG === /* Ok */0) {
          var orderUcVin = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUcVin"), null));
          if (orderUcVin.TAG === /* Ok */0) {
            var ucPoliceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "ucPoliceNumber"), null));
            if (ucPoliceNumber.TAG === /* Ok */0) {
              var orderUCFirstReleaseDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUCFirstReleaseDate"), null));
              if (orderUCFirstReleaseDate.TAG === /* Ok */0) {
                var orderUCLastRegistrationDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderUCLastRegistrationDate"), null));
                if (orderUCLastRegistrationDate.TAG === /* Ok */0) {
                  var orderRealTradeAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderRealTradeAmount"), null));
                  if (orderRealTradeAmount.TAG === /* Ok */0) {
                    var orderEstimatedTradeAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderEstimatedTradeAmount"), null));
                    if (orderEstimatedTradeAmount.TAG === /* Ok */0) {
                      var orderScrapyardIndicator = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderScrapyardIndicator"), null));
                      if (orderScrapyardIndicator.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  orderUcBrand: orderUcBrand._0,
                                  orderUcModel: orderUcModel._0,
                                  orderUcVersion: orderUcVersion._0,
                                  orderUcRegistrationId: orderUcRegistrationId._0,
                                  orderUcVin: orderUcVin._0,
                                  ucPoliceNumber: ucPoliceNumber._0,
                                  orderUCFirstReleaseDate: orderUCFirstReleaseDate._0,
                                  orderUCLastRegistrationDate: orderUCLastRegistrationDate._0,
                                  orderRealTradeAmount: orderRealTradeAmount._0,
                                  orderEstimatedTradeAmount: orderEstimatedTradeAmount._0,
                                  orderScrapyardIndicator: orderScrapyardIndicator._0
                                }
                              };
                      }
                      var e = orderScrapyardIndicator._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".orderScrapyardIndicator" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = orderEstimatedTradeAmount._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".orderEstimatedTradeAmount" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = orderRealTradeAmount._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".orderRealTradeAmount" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = orderUCLastRegistrationDate._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".orderUCLastRegistrationDate" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = orderUCFirstReleaseDate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".orderUCFirstReleaseDate" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = ucPoliceNumber._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".ucPoliceNumber" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = orderUcVin._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".orderUcVin" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = orderUcRegistrationId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".orderUcRegistrationId" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = orderUcVersion._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".orderUcVersion" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = orderUcModel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".orderUcModel" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = orderUcBrand._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orderUcBrand" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function orderHeader_encode(v) {
  return Js_dict.fromArray([
              [
                "orderDr",
                Decco.optionToJson(Decco.stringToJson, v.orderDr)
              ],
              [
                "orderDealerId",
                Decco.optionToJson(Decco.stringToJson, v.orderDealerId)
              ],
              [
                "dealerName",
                Decco.optionToJson(Decco.stringToJson, v.dealerName)
              ],
              [
                "dealerAgentName",
                Decco.optionToJson(Decco.stringToJson, v.dealerAgentName)
              ],
              [
                "orderCustomerOrderNumber",
                Decco.optionToJson(Decco.stringToJson, v.orderCustomerOrderNumber)
              ],
              [
                "orderCarOrderNumber",
                Decco.optionToJson(Decco.stringToJson, v.orderCarOrderNumber)
              ],
              [
                "orderOrderType",
                Decco.optionToJson(Order_Detail_Types_Order_Type$DvmAdminFrontendFr.Decco.t_encode, v.orderOrderType)
              ]
            ]);
}

function orderHeader_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var orderDr = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderDr"), null));
  if (orderDr.TAG === /* Ok */0) {
    var orderDealerId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderDealerId"), null));
    if (orderDealerId.TAG === /* Ok */0) {
      var dealerName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dealerName"), null));
      if (dealerName.TAG === /* Ok */0) {
        var dealerAgentName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dealerAgentName"), null));
        if (dealerAgentName.TAG === /* Ok */0) {
          var orderCustomerOrderNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerOrderNumber"), null));
          if (orderCustomerOrderNumber.TAG === /* Ok */0) {
            var orderCarOrderNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCarOrderNumber"), null));
            if (orderCarOrderNumber.TAG === /* Ok */0) {
              var orderOrderType = Decco.optionFromJson(Order_Detail_Types_Order_Type$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderOrderType"), null));
              if (orderOrderType.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          orderDr: orderDr._0,
                          orderDealerId: orderDealerId._0,
                          dealerName: dealerName._0,
                          dealerAgentName: dealerAgentName._0,
                          orderCustomerOrderNumber: orderCustomerOrderNumber._0,
                          orderCarOrderNumber: orderCarOrderNumber._0,
                          orderOrderType: orderOrderType._0
                        }
                      };
              }
              var e = orderOrderType._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".orderOrderType" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = orderCarOrderNumber._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".orderCarOrderNumber" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = orderCustomerOrderNumber._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".orderCustomerOrderNumber" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = dealerAgentName._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".dealerAgentName" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = dealerName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".dealerName" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = orderDealerId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".orderDealerId" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = orderDr._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orderDr" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function orderBody_encode(v) {
  return Js_dict.fromArray([
              [
                "orderSiret",
                Decco.optionToJson(Decco.stringToJson, v.orderSiret)
              ],
              [
                "siretName",
                Decco.optionToJson(Decco.stringToJson, v.siretName)
              ],
              [
                "orderCustomerName",
                Decco.optionToJson(Decco.stringToJson, v.orderCustomerName)
              ],
              [
                "orderCustomerFirstName",
                Decco.optionToJson(Decco.stringToJson, v.orderCustomerFirstName)
              ],
              [
                "contractIDLeaser",
                Decco.optionToJson(Decco.stringToJson, v.contractIDLeaser)
              ],
              [
                "contractIDFinalCustomer",
                Decco.optionToJson(Decco.stringToJson, v.contractIDFinalCustomer)
              ],
              [
                "orderSirenFinalCustomer",
                Decco.optionToJson(Decco.stringToJson, v.orderSirenFinalCustomer)
              ],
              [
                "sirenNameFinalCustomer",
                Decco.optionToJson(Decco.stringToJson, v.sirenNameFinalCustomer)
              ],
              [
                "orderModelId",
                Decco.optionToJson(Decco.stringToJson, v.orderModelId)
              ],
              [
                "orderPhase",
                Decco.optionToJson(Decco.stringToJson, v.orderPhase)
              ],
              [
                "orderVersionId",
                Decco.optionToJson(Decco.stringToJson, v.orderVersionId)
              ],
              [
                "orderRegistrationId",
                Decco.optionToJson(Decco.stringToJson, v.orderRegistrationId)
              ],
              [
                "orderVIN",
                Decco.optionToJson(Decco.stringToJson, v.orderVIN)
              ],
              [
                "orderOrderDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderOrderDate)
              ],
              [
                "orderRegistrationDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderRegistrationDate)
              ],
              [
                "orderCancellationDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderCancellationDate)
              ],
              [
                "resultDeliveryDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultDeliveryDate)
              ],
              [
                "orderLastModificationDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderLastModificationDate)
              ],
              [
                "orderMADCDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderMADCDate)
              ],
              [
                "orderMADADate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderMADADate)
              ],
              [
                "orderCustomerInvoiceNumber",
                Decco.optionToJson(Decco.stringToJson, v.orderCustomerInvoiceNumber)
              ],
              [
                "orderCustomerInvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderCustomerInvoiceDate)
              ],
              [
                "orderAgentCode",
                Decco.optionToJson(Decco.stringToJson, v.orderAgentCode)
              ],
              [
                "dealerLocationCommonName",
                Decco.optionToJson(Decco.stringToJson, v.dealerLocationCommonName)
              ],
              [
                "orderSalesmanName",
                Decco.optionToJson(Decco.stringToJson, v.orderSalesmanName)
              ],
              [
                "advensysInvoiceNumber",
                Decco.optionToJson(Decco.stringToJson, v.advensysInvoiceNumber)
              ],
              [
                "orderRenaultInvoiceDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderRenaultInvoiceDate)
              ],
              [
                "advensysTariffNumber",
                Decco.optionToJson(Decco.stringToJson, v.advensysTariffNumber)
              ],
              [
                "advensysPVCHT",
                Decco.optionToJson(Decco.floatToJson, v.advensysPVCHT)
              ],
              [
                "advensysPVCTTC",
                Decco.optionToJson(Decco.floatToJson, v.advensysPVCTTC)
              ],
              [
                "advensysNETPVR",
                Decco.optionToJson(Decco.floatToJson, v.advensysNETPVR)
              ],
              [
                "orderCustomerDiscount",
                Decco.optionToJson(Decco.floatToJson, v.orderCustomerDiscount)
              ],
              [
                "orderEasyPack",
                Decco.optionToJson(Decco.stringToJson, v.orderEasyPack)
              ],
              [
                "resultOrderArchived",
                Decco.optionToJson(Decco.boolToJson, v.resultOrderArchived)
              ],
              [
                "orderAcquisitionType",
                Decco.optionToJson(Decco.stringToJson, v.orderAcquisitionType)
              ],
              [
                "resultDelivered",
                Decco.optionToJson(Decco.boolToJson, v.resultDelivered)
              ],
              [
                "resultOrderStatus",
                Decco.optionToJson(App_Types_VN_VO_Status$DvmAdminFrontendFr.Decco.t_encode, v.resultOrderStatus)
              ],
              [
                "resultUCStatus",
                Decco.optionToJson(App_Types_VN_VO_Status$DvmAdminFrontendFr.Decco.t_encode, v.resultUCStatus)
              ],
              [
                "orderClientType",
                Decco.optionToJson(Decco.stringToJson, v.orderClientType)
              ],
              [
                "orderSaleType",
                Decco.optionToJson(Decco.stringToJson, v.orderSaleType)
              ],
              [
                "resultCalcPARCStartDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultCalcPARCStartDate)
              ],
              [
                "resultPARCEndDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.resultPARCEndDate)
              ],
              [
                "resultPARCEndDateAutoFlag",
                Decco.optionToJson(Decco.boolToJson, v.resultPARCEndDateAutoFlag)
              ],
              [
                "orderCATTC",
                Decco.optionToJson(Decco.floatToJson, v.orderCATTC)
              ],
              [
                "resultCAHT",
                Decco.optionToJson(Decco.floatToJson, v.resultCAHT)
              ],
              [
                "orderResoldOrderId",
                Decco.optionToJson(Decco.stringToJson, v.orderResoldOrderId)
              ],
              [
                "orderResellable",
                Decco.optionToJson(Decco.boolToJson, v.orderResellable)
              ],
              [
                "orderAttributionVehicleDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.orderAttributionVehicleDate)
              ]
            ]);
}

function orderBody_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var orderSiret = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderSiret"), null));
  if (orderSiret.TAG === /* Ok */0) {
    var siretName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "siretName"), null));
    if (siretName.TAG === /* Ok */0) {
      var orderCustomerName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerName"), null));
      if (orderCustomerName.TAG === /* Ok */0) {
        var orderCustomerFirstName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerFirstName"), null));
        if (orderCustomerFirstName.TAG === /* Ok */0) {
          var contractIDLeaser = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contractIDLeaser"), null));
          if (contractIDLeaser.TAG === /* Ok */0) {
            var contractIDFinalCustomer = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contractIDFinalCustomer"), null));
            if (contractIDFinalCustomer.TAG === /* Ok */0) {
              var orderSirenFinalCustomer = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderSirenFinalCustomer"), null));
              if (orderSirenFinalCustomer.TAG === /* Ok */0) {
                var sirenNameFinalCustomer = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sirenNameFinalCustomer"), null));
                if (sirenNameFinalCustomer.TAG === /* Ok */0) {
                  var orderModelId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderModelId"), null));
                  if (orderModelId.TAG === /* Ok */0) {
                    var orderPhase = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderPhase"), null));
                    if (orderPhase.TAG === /* Ok */0) {
                      var orderVersionId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderVersionId"), null));
                      if (orderVersionId.TAG === /* Ok */0) {
                        var orderRegistrationId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderRegistrationId"), null));
                        if (orderRegistrationId.TAG === /* Ok */0) {
                          var orderVIN = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderVIN"), null));
                          if (orderVIN.TAG === /* Ok */0) {
                            var orderOrderDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderOrderDate"), null));
                            if (orderOrderDate.TAG === /* Ok */0) {
                              var orderRegistrationDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderRegistrationDate"), null));
                              if (orderRegistrationDate.TAG === /* Ok */0) {
                                var orderCancellationDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCancellationDate"), null));
                                if (orderCancellationDate.TAG === /* Ok */0) {
                                  var resultDeliveryDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultDeliveryDate"), null));
                                  if (resultDeliveryDate.TAG === /* Ok */0) {
                                    var orderLastModificationDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderLastModificationDate"), null));
                                    if (orderLastModificationDate.TAG === /* Ok */0) {
                                      var orderMADCDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderMADCDate"), null));
                                      if (orderMADCDate.TAG === /* Ok */0) {
                                        var orderMADADate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderMADADate"), null));
                                        if (orderMADADate.TAG === /* Ok */0) {
                                          var orderCustomerInvoiceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerInvoiceNumber"), null));
                                          if (orderCustomerInvoiceNumber.TAG === /* Ok */0) {
                                            var orderCustomerInvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerInvoiceDate"), null));
                                            if (orderCustomerInvoiceDate.TAG === /* Ok */0) {
                                              var orderAgentCode = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderAgentCode"), null));
                                              if (orderAgentCode.TAG === /* Ok */0) {
                                                var dealerLocationCommonName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dealerLocationCommonName"), null));
                                                if (dealerLocationCommonName.TAG === /* Ok */0) {
                                                  var orderSalesmanName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderSalesmanName"), null));
                                                  if (orderSalesmanName.TAG === /* Ok */0) {
                                                    var advensysInvoiceNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "advensysInvoiceNumber"), null));
                                                    if (advensysInvoiceNumber.TAG === /* Ok */0) {
                                                      var orderRenaultInvoiceDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderRenaultInvoiceDate"), null));
                                                      if (orderRenaultInvoiceDate.TAG === /* Ok */0) {
                                                        var advensysTariffNumber = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "advensysTariffNumber"), null));
                                                        if (advensysTariffNumber.TAG === /* Ok */0) {
                                                          var advensysPVCHT = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "advensysPVCHT"), null));
                                                          if (advensysPVCHT.TAG === /* Ok */0) {
                                                            var advensysPVCTTC = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "advensysPVCTTC"), null));
                                                            if (advensysPVCTTC.TAG === /* Ok */0) {
                                                              var advensysNETPVR = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "advensysNETPVR"), null));
                                                              if (advensysNETPVR.TAG === /* Ok */0) {
                                                                var orderCustomerDiscount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCustomerDiscount"), null));
                                                                if (orderCustomerDiscount.TAG === /* Ok */0) {
                                                                  var orderEasyPack = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderEasyPack"), null));
                                                                  if (orderEasyPack.TAG === /* Ok */0) {
                                                                    var resultOrderArchived = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultOrderArchived"), null));
                                                                    if (resultOrderArchived.TAG === /* Ok */0) {
                                                                      var orderAcquisitionType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderAcquisitionType"), null));
                                                                      if (orderAcquisitionType.TAG === /* Ok */0) {
                                                                        var resultDelivered = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultDelivered"), null));
                                                                        if (resultDelivered.TAG === /* Ok */0) {
                                                                          var resultOrderStatus = Decco.optionFromJson(App_Types_VN_VO_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultOrderStatus"), null));
                                                                          if (resultOrderStatus.TAG === /* Ok */0) {
                                                                            var resultUCStatus = Decco.optionFromJson(App_Types_VN_VO_Status$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultUCStatus"), null));
                                                                            if (resultUCStatus.TAG === /* Ok */0) {
                                                                              var orderClientType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderClientType"), null));
                                                                              if (orderClientType.TAG === /* Ok */0) {
                                                                                var orderSaleType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderSaleType"), null));
                                                                                if (orderSaleType.TAG === /* Ok */0) {
                                                                                  var resultCalcPARCStartDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultCalcPARCStartDate"), null));
                                                                                  if (resultCalcPARCStartDate.TAG === /* Ok */0) {
                                                                                    var resultPARCEndDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPARCEndDate"), null));
                                                                                    if (resultPARCEndDate.TAG === /* Ok */0) {
                                                                                      var resultPARCEndDateAutoFlag = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultPARCEndDateAutoFlag"), null));
                                                                                      if (resultPARCEndDateAutoFlag.TAG === /* Ok */0) {
                                                                                        var orderCATTC = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderCATTC"), null));
                                                                                        if (orderCATTC.TAG === /* Ok */0) {
                                                                                          var resultCAHT = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resultCAHT"), null));
                                                                                          if (resultCAHT.TAG === /* Ok */0) {
                                                                                            var orderResoldOrderId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderResoldOrderId"), null));
                                                                                            if (orderResoldOrderId.TAG === /* Ok */0) {
                                                                                              var orderResellable = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderResellable"), null));
                                                                                              if (orderResellable.TAG === /* Ok */0) {
                                                                                                var orderAttributionVehicleDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderAttributionVehicleDate"), null));
                                                                                                if (orderAttributionVehicleDate.TAG === /* Ok */0) {
                                                                                                  return {
                                                                                                          TAG: /* Ok */0,
                                                                                                          _0: {
                                                                                                            orderSiret: orderSiret._0,
                                                                                                            siretName: siretName._0,
                                                                                                            orderCustomerName: orderCustomerName._0,
                                                                                                            orderCustomerFirstName: orderCustomerFirstName._0,
                                                                                                            contractIDLeaser: contractIDLeaser._0,
                                                                                                            contractIDFinalCustomer: contractIDFinalCustomer._0,
                                                                                                            orderSirenFinalCustomer: orderSirenFinalCustomer._0,
                                                                                                            sirenNameFinalCustomer: sirenNameFinalCustomer._0,
                                                                                                            orderModelId: orderModelId._0,
                                                                                                            orderPhase: orderPhase._0,
                                                                                                            orderVersionId: orderVersionId._0,
                                                                                                            orderRegistrationId: orderRegistrationId._0,
                                                                                                            orderVIN: orderVIN._0,
                                                                                                            orderOrderDate: orderOrderDate._0,
                                                                                                            orderRegistrationDate: orderRegistrationDate._0,
                                                                                                            orderCancellationDate: orderCancellationDate._0,
                                                                                                            resultDeliveryDate: resultDeliveryDate._0,
                                                                                                            orderLastModificationDate: orderLastModificationDate._0,
                                                                                                            orderMADCDate: orderMADCDate._0,
                                                                                                            orderMADADate: orderMADADate._0,
                                                                                                            orderCustomerInvoiceNumber: orderCustomerInvoiceNumber._0,
                                                                                                            orderCustomerInvoiceDate: orderCustomerInvoiceDate._0,
                                                                                                            orderAgentCode: orderAgentCode._0,
                                                                                                            dealerLocationCommonName: dealerLocationCommonName._0,
                                                                                                            orderSalesmanName: orderSalesmanName._0,
                                                                                                            advensysInvoiceNumber: advensysInvoiceNumber._0,
                                                                                                            orderRenaultInvoiceDate: orderRenaultInvoiceDate._0,
                                                                                                            advensysTariffNumber: advensysTariffNumber._0,
                                                                                                            advensysPVCHT: advensysPVCHT._0,
                                                                                                            advensysPVCTTC: advensysPVCTTC._0,
                                                                                                            advensysNETPVR: advensysNETPVR._0,
                                                                                                            orderCustomerDiscount: orderCustomerDiscount._0,
                                                                                                            orderEasyPack: orderEasyPack._0,
                                                                                                            resultOrderArchived: resultOrderArchived._0,
                                                                                                            orderAcquisitionType: orderAcquisitionType._0,
                                                                                                            resultDelivered: resultDelivered._0,
                                                                                                            resultOrderStatus: resultOrderStatus._0,
                                                                                                            resultUCStatus: resultUCStatus._0,
                                                                                                            orderClientType: orderClientType._0,
                                                                                                            orderSaleType: orderSaleType._0,
                                                                                                            resultCalcPARCStartDate: resultCalcPARCStartDate._0,
                                                                                                            resultPARCEndDate: resultPARCEndDate._0,
                                                                                                            resultPARCEndDateAutoFlag: resultPARCEndDateAutoFlag._0,
                                                                                                            orderCATTC: orderCATTC._0,
                                                                                                            resultCAHT: resultCAHT._0,
                                                                                                            orderResoldOrderId: orderResoldOrderId._0,
                                                                                                            orderResellable: orderResellable._0,
                                                                                                            orderAttributionVehicleDate: orderAttributionVehicleDate._0
                                                                                                          }
                                                                                                        };
                                                                                                }
                                                                                                var e = orderAttributionVehicleDate._0;
                                                                                                return {
                                                                                                        TAG: /* Error */1,
                                                                                                        _0: {
                                                                                                          path: ".orderAttributionVehicleDate" + e.path,
                                                                                                          message: e.message,
                                                                                                          value: e.value
                                                                                                        }
                                                                                                      };
                                                                                              }
                                                                                              var e$1 = orderResellable._0;
                                                                                              return {
                                                                                                      TAG: /* Error */1,
                                                                                                      _0: {
                                                                                                        path: ".orderResellable" + e$1.path,
                                                                                                        message: e$1.message,
                                                                                                        value: e$1.value
                                                                                                      }
                                                                                                    };
                                                                                            }
                                                                                            var e$2 = orderResoldOrderId._0;
                                                                                            return {
                                                                                                    TAG: /* Error */1,
                                                                                                    _0: {
                                                                                                      path: ".orderResoldOrderId" + e$2.path,
                                                                                                      message: e$2.message,
                                                                                                      value: e$2.value
                                                                                                    }
                                                                                                  };
                                                                                          }
                                                                                          var e$3 = resultCAHT._0;
                                                                                          return {
                                                                                                  TAG: /* Error */1,
                                                                                                  _0: {
                                                                                                    path: ".resultCAHT" + e$3.path,
                                                                                                    message: e$3.message,
                                                                                                    value: e$3.value
                                                                                                  }
                                                                                                };
                                                                                        }
                                                                                        var e$4 = orderCATTC._0;
                                                                                        return {
                                                                                                TAG: /* Error */1,
                                                                                                _0: {
                                                                                                  path: ".orderCATTC" + e$4.path,
                                                                                                  message: e$4.message,
                                                                                                  value: e$4.value
                                                                                                }
                                                                                              };
                                                                                      }
                                                                                      var e$5 = resultPARCEndDateAutoFlag._0;
                                                                                      return {
                                                                                              TAG: /* Error */1,
                                                                                              _0: {
                                                                                                path: ".resultPARCEndDateAutoFlag" + e$5.path,
                                                                                                message: e$5.message,
                                                                                                value: e$5.value
                                                                                              }
                                                                                            };
                                                                                    }
                                                                                    var e$6 = resultPARCEndDate._0;
                                                                                    return {
                                                                                            TAG: /* Error */1,
                                                                                            _0: {
                                                                                              path: ".resultPARCEndDate" + e$6.path,
                                                                                              message: e$6.message,
                                                                                              value: e$6.value
                                                                                            }
                                                                                          };
                                                                                  }
                                                                                  var e$7 = resultCalcPARCStartDate._0;
                                                                                  return {
                                                                                          TAG: /* Error */1,
                                                                                          _0: {
                                                                                            path: ".resultCalcPARCStartDate" + e$7.path,
                                                                                            message: e$7.message,
                                                                                            value: e$7.value
                                                                                          }
                                                                                        };
                                                                                }
                                                                                var e$8 = orderSaleType._0;
                                                                                return {
                                                                                        TAG: /* Error */1,
                                                                                        _0: {
                                                                                          path: ".orderSaleType" + e$8.path,
                                                                                          message: e$8.message,
                                                                                          value: e$8.value
                                                                                        }
                                                                                      };
                                                                              }
                                                                              var e$9 = orderClientType._0;
                                                                              return {
                                                                                      TAG: /* Error */1,
                                                                                      _0: {
                                                                                        path: ".orderClientType" + e$9.path,
                                                                                        message: e$9.message,
                                                                                        value: e$9.value
                                                                                      }
                                                                                    };
                                                                            }
                                                                            var e$10 = resultUCStatus._0;
                                                                            return {
                                                                                    TAG: /* Error */1,
                                                                                    _0: {
                                                                                      path: ".resultUCStatus" + e$10.path,
                                                                                      message: e$10.message,
                                                                                      value: e$10.value
                                                                                    }
                                                                                  };
                                                                          }
                                                                          var e$11 = resultOrderStatus._0;
                                                                          return {
                                                                                  TAG: /* Error */1,
                                                                                  _0: {
                                                                                    path: ".resultOrderStatus" + e$11.path,
                                                                                    message: e$11.message,
                                                                                    value: e$11.value
                                                                                  }
                                                                                };
                                                                        }
                                                                        var e$12 = resultDelivered._0;
                                                                        return {
                                                                                TAG: /* Error */1,
                                                                                _0: {
                                                                                  path: ".resultDelivered" + e$12.path,
                                                                                  message: e$12.message,
                                                                                  value: e$12.value
                                                                                }
                                                                              };
                                                                      }
                                                                      var e$13 = orderAcquisitionType._0;
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: {
                                                                                path: ".orderAcquisitionType" + e$13.path,
                                                                                message: e$13.message,
                                                                                value: e$13.value
                                                                              }
                                                                            };
                                                                    }
                                                                    var e$14 = resultOrderArchived._0;
                                                                    return {
                                                                            TAG: /* Error */1,
                                                                            _0: {
                                                                              path: ".resultOrderArchived" + e$14.path,
                                                                              message: e$14.message,
                                                                              value: e$14.value
                                                                            }
                                                                          };
                                                                  }
                                                                  var e$15 = orderEasyPack._0;
                                                                  return {
                                                                          TAG: /* Error */1,
                                                                          _0: {
                                                                            path: ".orderEasyPack" + e$15.path,
                                                                            message: e$15.message,
                                                                            value: e$15.value
                                                                          }
                                                                        };
                                                                }
                                                                var e$16 = orderCustomerDiscount._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".orderCustomerDiscount" + e$16.path,
                                                                          message: e$16.message,
                                                                          value: e$16.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$17 = advensysNETPVR._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".advensysNETPVR" + e$17.path,
                                                                        message: e$17.message,
                                                                        value: e$17.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$18 = advensysPVCTTC._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".advensysPVCTTC" + e$18.path,
                                                                      message: e$18.message,
                                                                      value: e$18.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$19 = advensysPVCHT._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".advensysPVCHT" + e$19.path,
                                                                    message: e$19.message,
                                                                    value: e$19.value
                                                                  }
                                                                };
                                                        }
                                                        var e$20 = advensysTariffNumber._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".advensysTariffNumber" + e$20.path,
                                                                  message: e$20.message,
                                                                  value: e$20.value
                                                                }
                                                              };
                                                      }
                                                      var e$21 = orderRenaultInvoiceDate._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".orderRenaultInvoiceDate" + e$21.path,
                                                                message: e$21.message,
                                                                value: e$21.value
                                                              }
                                                            };
                                                    }
                                                    var e$22 = advensysInvoiceNumber._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".advensysInvoiceNumber" + e$22.path,
                                                              message: e$22.message,
                                                              value: e$22.value
                                                            }
                                                          };
                                                  }
                                                  var e$23 = orderSalesmanName._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".orderSalesmanName" + e$23.path,
                                                            message: e$23.message,
                                                            value: e$23.value
                                                          }
                                                        };
                                                }
                                                var e$24 = dealerLocationCommonName._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".dealerLocationCommonName" + e$24.path,
                                                          message: e$24.message,
                                                          value: e$24.value
                                                        }
                                                      };
                                              }
                                              var e$25 = orderAgentCode._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".orderAgentCode" + e$25.path,
                                                        message: e$25.message,
                                                        value: e$25.value
                                                      }
                                                    };
                                            }
                                            var e$26 = orderCustomerInvoiceDate._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".orderCustomerInvoiceDate" + e$26.path,
                                                      message: e$26.message,
                                                      value: e$26.value
                                                    }
                                                  };
                                          }
                                          var e$27 = orderCustomerInvoiceNumber._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".orderCustomerInvoiceNumber" + e$27.path,
                                                    message: e$27.message,
                                                    value: e$27.value
                                                  }
                                                };
                                        }
                                        var e$28 = orderMADADate._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".orderMADADate" + e$28.path,
                                                  message: e$28.message,
                                                  value: e$28.value
                                                }
                                              };
                                      }
                                      var e$29 = orderMADCDate._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".orderMADCDate" + e$29.path,
                                                message: e$29.message,
                                                value: e$29.value
                                              }
                                            };
                                    }
                                    var e$30 = orderLastModificationDate._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".orderLastModificationDate" + e$30.path,
                                              message: e$30.message,
                                              value: e$30.value
                                            }
                                          };
                                  }
                                  var e$31 = resultDeliveryDate._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".resultDeliveryDate" + e$31.path,
                                            message: e$31.message,
                                            value: e$31.value
                                          }
                                        };
                                }
                                var e$32 = orderCancellationDate._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".orderCancellationDate" + e$32.path,
                                          message: e$32.message,
                                          value: e$32.value
                                        }
                                      };
                              }
                              var e$33 = orderRegistrationDate._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".orderRegistrationDate" + e$33.path,
                                        message: e$33.message,
                                        value: e$33.value
                                      }
                                    };
                            }
                            var e$34 = orderOrderDate._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".orderOrderDate" + e$34.path,
                                      message: e$34.message,
                                      value: e$34.value
                                    }
                                  };
                          }
                          var e$35 = orderVIN._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".orderVIN" + e$35.path,
                                    message: e$35.message,
                                    value: e$35.value
                                  }
                                };
                        }
                        var e$36 = orderRegistrationId._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".orderRegistrationId" + e$36.path,
                                  message: e$36.message,
                                  value: e$36.value
                                }
                              };
                      }
                      var e$37 = orderVersionId._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".orderVersionId" + e$37.path,
                                message: e$37.message,
                                value: e$37.value
                              }
                            };
                    }
                    var e$38 = orderPhase._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".orderPhase" + e$38.path,
                              message: e$38.message,
                              value: e$38.value
                            }
                          };
                  }
                  var e$39 = orderModelId._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".orderModelId" + e$39.path,
                            message: e$39.message,
                            value: e$39.value
                          }
                        };
                }
                var e$40 = sirenNameFinalCustomer._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".sirenNameFinalCustomer" + e$40.path,
                          message: e$40.message,
                          value: e$40.value
                        }
                      };
              }
              var e$41 = orderSirenFinalCustomer._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".orderSirenFinalCustomer" + e$41.path,
                        message: e$41.message,
                        value: e$41.value
                      }
                    };
            }
            var e$42 = contractIDFinalCustomer._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".contractIDFinalCustomer" + e$42.path,
                      message: e$42.message,
                      value: e$42.value
                    }
                  };
          }
          var e$43 = contractIDLeaser._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".contractIDLeaser" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
        }
        var e$44 = orderCustomerFirstName._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".orderCustomerFirstName" + e$44.path,
                  message: e$44.message,
                  value: e$44.value
                }
              };
      }
      var e$45 = orderCustomerName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".orderCustomerName" + e$45.path,
                message: e$45.message,
                value: e$45.value
              }
            };
    }
    var e$46 = siretName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".siretName" + e$46.path,
              message: e$46.message,
              value: e$46.value
            }
          };
  }
  var e$47 = orderSiret._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orderSiret" + e$47.path,
            message: e$47.message,
            value: e$47.value
          }
        };
}

function order_encode(v) {
  return Js_dict.fromArray([
              [
                "header",
                orderHeader_encode(v.header)
              ],
              [
                "body",
                orderBody_encode(v.body)
              ],
              [
                "usedCar",
                Decco.optionToJson(orderUsedCar_encode, v.usedCar)
              ],
              [
                "budgetBonus",
                Decco.optionToJson(t_encode$2, v.budgetBonus)
              ],
              [
                "bonuses",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(t_encode$1, param);
                      }), v.bonuses)
              ],
              [
                "orderDeros",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(t_encode, param);
                      }), v.orderDeros)
              ]
            ]);
}

function order_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var header = orderHeader_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "header"), null));
  if (header.TAG === /* Ok */0) {
    var body = orderBody_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "body"), null));
    if (body.TAG === /* Ok */0) {
      var usedCar = Decco.optionFromJson(orderUsedCar_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "usedCar"), null));
      if (usedCar.TAG === /* Ok */0) {
        var budgetBonus = Decco.optionFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "budgetBonus"), null));
        if (budgetBonus.TAG === /* Ok */0) {
          var bonuses = Decco.optionFromJson((function (param) {
                  return Decco.listFromJson(t_decode$1, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "bonuses"), null));
          if (bonuses.TAG === /* Ok */0) {
            var orderDeros = Decco.optionFromJson((function (param) {
                    return Decco.listFromJson(t_decode, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderDeros"), null));
            if (orderDeros.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        header: header._0,
                        body: body._0,
                        usedCar: usedCar._0,
                        budgetBonus: budgetBonus._0,
                        bonuses: bonuses._0,
                        orderDeros: orderDeros._0
                      }
                    };
            }
            var e = orderDeros._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".orderDeros" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = bonuses._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".bonuses" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = budgetBonus._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".budgetBonus" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = usedCar._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".usedCar" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = body._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".body" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = header._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".header" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

export {
  bonusChangeInfo_encode ,
  bonusChangeInfo_decode ,
  MessageType ,
  messagesItem_encode ,
  messagesItem_decode ,
  OrderDero ,
  OrderBonus ,
  OrderBudget ,
  orderUsedCar_encode ,
  orderUsedCar_decode ,
  orderHeader_encode ,
  orderHeader_decode ,
  orderBody_encode ,
  orderBody_decode ,
  order_encode ,
  order_decode ,
}
/* Decco Not a pure module */
